import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/firestore'
import VuePromiseBtn from 'vue-promise-btn';
import 'vue-promise-btn/dist/vue-promise-btn.css';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VueMask from 'v-mask'
import VuePageTitle from 'vue-page-title';

firebase.initializeApp({
  apiKey: "AIzaSyBaS5PSHM2tOR_44Zx7x9JZ2eLJoJAbI5w",
  authDomain: "davnrw-574ce.firebaseapp.com",
  databaseURL: "https://davnrw-574ce.firebaseio.com",
  projectId: "davnrw-574ce",
  storageBucket: "davnrw-574ce.appspot.com",
  messagingSenderId: "346770311946",
  appId: "1:346770311946:web:f3f01a3db3dcf204b508f3",
  measurementId: "G-QC8R1WBK8P"
})

Vue.config.productionTip = false

Vue.use(VuePromiseBtn)
Vue.use(VueMask);
Vue.use(VuePageTitle, {
  // prefix: 'My App - ',
  suffix: '- Sportklettern NRW ',
});


new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
